import React from 'react';
import PropTypes from 'prop-types';
import { CardTag, CardImageContainer, CardContainer, CardHeading, CardPrice } from "./styles";

const WaysCard = ({ img, heading, price, textColor }) => (
  <CardTag>
    <CardImageContainer>
      <img src={img} alt={heading} />
    </CardImageContainer>
    <CardContainer textColor={textColor}>
      <CardHeading>{heading}</CardHeading>
      <CardPrice>from <span>${price}</span>/guest</CardPrice>
    </CardContainer>
  </CardTag>
);

WaysCard.propTypes = {
  img: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  textColor: PropTypes.string.isRequired
};

export default WaysCard;
